import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IModule, INgModelController, IPromise} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {Beslutningsskjemamodell, BeslutningTjeneste} from "../../BeslutningTjeneste";
import {MdDialogController} from "../../../../tjenester/Dialog";

const css = require('./redigerBeslutningDialog.scss');

export function registrerRedigerBeslutningDialog(angular: IModule) {
    angular
        .service(RedigerBeslutningDialog.regNavn, RedigerBeslutningDialog.forInjisering())
        .controller(RedigerBeslutningDialogKontroller.regNavn, RedigerBeslutningDialogKontroller.forInjisering());
}

export class RedigerBeslutningDialog {
    static regNavn = "wm.møte.modale.redigerBeslutningDialog.RedigerBeslutningDialog";

    static forInjisering() {
        return [
            regNavn.md.$mdDialog,
            RedigerBeslutningDialog
        ]
    }

    constructor(private $mdDialog: angular.material.IDialogService) {
    }

    private dialogKonfigurasjon = {
        template: require('./redigerBeslutningDialog.html'),
        controller: RedigerBeslutningDialogKontroller.regNavn,
        controllerAs: 'ktr',
        bindToController: true
    };

    visRedigerBeslutningDialog(beslutning: l.BeslutningModell): IPromise<l.BeslutningModell> {
        return this.$mdDialog.show(_.defaults({}, this.dialogKonfigurasjon, {locals: {beslutning: beslutning, gruppeId: beslutning.eiendeGruppeId}}));
    }

    visNyBeslutningDialog(sakId: string, gruppeId: string): IPromise<l.BeslutningModell> {
        return this.$mdDialog.show(_.defaults({}, this.dialogKonfigurasjon, {locals: {sakId: sakId, gruppeId:gruppeId, erForslag: false}}));
    }

    visForslagTilNyBeslutningDialog(sakId: string, gruppeId: string): IPromise<l.BeslutningModell> {
        return this.$mdDialog.show(_.defaults({}, this.dialogKonfigurasjon, {locals: {sakId: sakId, gruppeId:gruppeId, erForslag: true}}));
    }

    visNyFerdigutfyltBeslutningDialog(sakId: string, gruppeId: string, tittel:string, beskrivelse:string): IPromise<l.BeslutningModell> {
        return this.$mdDialog.show(_.defaults({}, this.dialogKonfigurasjon, {locals: {sakId: sakId, gruppeId:gruppeId, erForslag: false, mal: {tittel: tittel, beskrivelse:beskrivelse}}}));
    }
}

export class RedigerBeslutningDialogKontroller implements MdDialogController {
    static regNavn = "wm.møte.modale.redigerBeslutningDialog.RedigerBeslutningDialogKontroller";

    static forInjisering() {
        return [
            BeslutningTjeneste.regNavn,
            regNavn.md.$mdDialog,
            RedigerBeslutningDialogKontroller
        ]
    }


    constructor(private beslutningTjeneste: BeslutningTjeneste,
                private $mdDialog: angular.material.IDialogService) {
    }

    $onInit(){
        this.initData();
    }

    beslutning: l.BeslutningModell; //satt via locals.beslutning i dialogKonfigurasjon
    gruppeId: string; //satt via locals.gruppeId i dialogKonfigurasjon
    sakId: string; //satt via locals.sakId i dialogKonfigurasjon ved visNyBeslutningDialog/visNyFerdigutfyltBeslutningDialog
    erForslag: boolean; //satt via locals.erForslag i dialogKonfigurasjon ved visNyBeslutningDialog/visNyFerdigutfyltBeslutningDialog
    mal: {tittel: string; beskrivelse:string;}; //satt via locals.sak i dialogKonfigurasjon ved visNyFerdigutfyltBeslutningDialog
    beslutningskjemamodell: Beslutningsskjemamodell;
    modus: 'nyttForslag'|'ny'|'redigerForslag'|'rediger';

    lagrer = false;


    lagre(skjema) {
        if (!skjema.$valid) return;
        this.lagrer = true;
        (this.modus == 'rediger' || this.modus == 'redigerForslag' ?
            this.beslutningTjeneste.oppdaterBeslutning(this.beslutningskjemamodell) :
            this.beslutningTjeneste.opprettBeslutning(this.beslutningskjemamodell))
            .then(beslutning => {
                this.$mdDialog.hide(beslutning);
            })
            .finally(() => this.lagrer = false);
    }

    avbryt() {
        this.$mdDialog.cancel();
    }

    validerTittel(tittel:INgModelController, beskrivelse:INgModelController){
        if (!tittel.$dirty && !beskrivelse.$dirty) return true; // ingen valideringsfeil før man har skrevet noe
        return !this.beggeTomme(tittel, beskrivelse);
    }

    // både tittel og beskrivlese kan ikke være tomme. Dersom feil vises feilen i tittelfeltet.
    validerBeskrivelse(tittel:INgModelController, beskrivelse:INgModelController){
        if (!tittel.$dirty && !beskrivelse.$dirty) return true; // ingen valideringsfeil før man har skrevet noe
        if (!this.beggeTomme(tittel, beskrivelse)){
            tittel.$setValidity("valideringsuttrykk",true);
        } else {
            tittel.$setValidity("valideringsuttrykk",false);
        }
        // valideringsfeil legges på tittel, setter ikke valideringsfeil på beskrivelse
        return true;
    }

    private beggeTomme(tittel: INgModelController, beskrivelse: INgModelController): boolean {
        return  this.feltTomt(tittel) && this.feltTomt(beskrivelse);
    }
    
    private feltTomt(felt: INgModelController):boolean {
        return _.isEmpty(felt.$viewValue);
    }

    //hjelpemetoder

    private initData() {
        if (this.sakId) {
            this.beslutningskjemamodell = this.beslutningTjeneste.initNyBeslutningSkjemaModell(this.sakId);
            if (this.mal){
                this.beslutningskjemamodell.spesifikasjon.tittel = this.mal.tittel;
                this.beslutningskjemamodell.spesifikasjon.beskrivelse = this.mal.beskrivelse;
            }
            this.beslutningskjemamodell.spesifikasjon.erForslag = this.erForslag;
            this.modus = this.erForslag ? 'nyttForslag' : 'ny';
            return;
        }

        //rediger beslutning
        this.beslutningskjemamodell = this.beslutningTjeneste.initRedigerBeslutningSkjemaModell(this.beslutning);
        this.modus = this.beslutning.erForslag ? 'redigerForslag' : 'rediger';
    }

}
